// https://www.npmjs.com/package/react-device-detect
// https://github.com/duskload/react-device-detect/blob/HEAD/docs/selectors.md

import * as deviceInfo from 'react-device-detect';

/*
    isBrowser
    isMobile
    isTablet
    isIE
    browserName
    isAndroid
    isIOS
    isWinPhone
    isChrome
	isFirefox
	isSafari
	isOpera
	isIE
	isEdge
	isChromium
	isMobileSafari
	isSamsungBrowser
	osVersion
	osName
	fullBrowserVersion
	mobileVendor
	mobileModel
	engineName
	engineVersion
	getUA
	isWindows
	isMacOs
	deviceDetect => "{\"deviceDetect\":{\"isBrowser\":true,\"browserMajorVersion\":\"130\",\"browserFullVersion\":\"130.0.0.0\",\"browserName\":\"Chrome\",\"engineName\":\"Blink\",\"engineVersion\":\"130.0.0.0\",\"osName\":\"Linux\",\"osVersion\":\"x86_64\",\"userAgent\":\"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/130.0.0.0 Safari/537.36\"}}"
*/
export const getDeviceInfo = () => {

	var deviceDetect = JSON.parse(localStorage.getItem("device"));

	// get info only if not there yet
	if(!deviceDetect || deviceDetect.length === 0){
		deviceDetect = JSON.stringify(deviceInfo.deviceDetect());
		localStorage.setItem("device",deviceDetect); 
	}

	return deviceDetect;
}

export const isIOS = () => {
	// iPad es detectado como 'Macintosh' con la propiedad touchPoints
	//const isIPad = navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints > 0;
	//const isIPhone = navigator.userAgent.includes('iPhone');
	//const isIPod = navigator.userAgent.includes('iPod');
	//return isIPad || isIPhone || isIPod;	
	return deviceInfo.isIOS;
};